import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

function usePodcastCategory() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();
  function addCategory(data) {
    return privateFetch.post('/v1/admin/podcast/supporting/categories', data);
  }

  function updateCategory({ categoryId, ...rest }) {
    return privateFetch.put(`/v1/admin/podcast/supporting/category/${categoryId}`, rest);
  }

  function manageCategory(data) {
    if (data.categoryId) return updateCategory(data);
    return addCategory(data);
  }

  return useMutation(manageCategory, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('podcast-category');
    },
  });
}

export default usePodcastCategory;
